import React from 'react';
import { connect } from "react-redux";
import {Button, Confirm, Grid, Modal} from "semantic-ui-react";
import Header from "../../../common/components/Header";
import Breadcrumb from '../../../common/partials/Breadcrumb';
import { setBreadCrumb } from '../../../veritas/breadcrumb/BreadcrumbActions';
import Select from "react-select";
import {
    closeBillingRecordsModal, deleteBillingRecord,
    getBillingRecords, getFormOptions,
    selectMonth,
    selectYear,
    toggleAddRecordsModal, toggleDeleteWarningForRecord, unmountBillingRecords, validateBillingRecord
} from "../actions/ManualEntryRecordsActions";
import ManualEntryRecordsTable from "./ManualEntryRecordsTable";
import AddEditBillingRecordForm from "./AddEditBillingRecordForm";

import MONTH_OPTIONS from "../../../common/resources/monthOptions.json";
import YEAR_OPTIONS from "../../../common/utils/yearOptions";
import Sidebar from "../../../common/components/Sidebar";
import BillingSidebarButtons from "../../shared/BillingSidebarButtons";
import * as Validation from "../../../common/utils/Validation";


export class ManualEntryRecordsListPage extends React.Component {

    state = {
        showRecordsTable: false,
    }

    componentDidMount() {
        document.title = `Billing - Manual Entry Records`;

        this.props.setBreadCrumb({
            parent: { url: '/billing', text: 'Billing   ' },
            list: { url: '/billing/manual-entry-records', text: 'Manual Entry Records' },
            service: { url: '', text: '' },
            source: { url: '', text: '' }
        });

        this.props.getBRecords(this.formattedSelectedYear);
        this.setState({showRecordsTable: true});
        this.props.populateFormOptions();
    }

    componentWillUnmount() {
        this.props.unmountManualEntryBillingRecords();
    }

    get formattedSelectedYear() {
        return this.props.selectedYear.value + "-" + this.props.selectedMonth.value;
    }

    handleSelectYear = (filterOption) => {
        this.props.setYear(filterOption);
        setTimeout(() => {
            this.handleGetRecords();
            }, 500);
    }

    handleSelectMonth = (filterOption) => {
        this.props.setMonth(filterOption);
        setTimeout(() => {
            this.handleGetRecords();
            }, 500);
    }

    handleGetRecords = () => {
        this.props.getBRecords(this.formattedSelectedYear);
        this.setState({showRecordsTable: true});
    }

    handleAddNewRecordClick = () => {
        this.props.toggleAddModal(this.props.selectedMonth.label + " " + this.props.selectedYear.label);
        this.props.populateFormOptions();
    }

    handleCloseModal = () => {
        Validation.clearMessages();
        this.props.closeAddEditModal();
    }

    validateBillingRecordFormBeforeSubmit = (e) => {
        e.preventDefault();
        this.props.billingRecordObject.selectedYear = this.props.selectedYear.value;
        this.props.billingRecordObject.selectedMonth = this.props.selectedMonth.value;
        this.props.validateManualEntryRecord(this.props.billingRecordObject, false);
    }

    validateBillingRecordFormBeforeSubmitAndClear = (e) => {
        e.preventDefault();
        this.props.billingRecordObject.selectedYear = this.props.selectedYear.value;
        this.props.billingRecordObject.selectedMonth = this.props.selectedMonth.value;
        this.props.validateManualEntryRecord(this.props.billingRecordObject, true);
    }

    handleCancelDeleteBillingRecordClick = () => {
        this.props.toggleDeleteBillingRecordModal();
    }

    handleDeleteBillingRecordClick = () => {
        this.props.deleteCurrentBillingRecord(this.props.recordIDForDelete, this.formattedSelectedYear);
    }

    get rangeSelectionContent() {
        return (
            <div>
                <p>Please Select the Year and Month to View the Manual Entry Billing Records.</p>
                <div className={"records-range-selection"}>
                    <Select
                        styles={{
                            menu: provided => ({ ...provided, zIndex: 9999 })
                        }}
                        onChange={this.handleSelectYear}
                        options={YEAR_OPTIONS}
                        placeholder={"Select A Year"}
                        isSearchable={true}
                        isClearable={true}
                        getOptionLabel={option => option.label}
                        getOptionValue={option => option.value}
                        value={this.props.selectedYear}
                    />
                    <Select
                        styles={{
                            menu: provided => ({ ...provided, zIndex: 9999 })
                        }}
                        onChange={this.handleSelectMonth}
                        options={MONTH_OPTIONS}
                        placeholder={"Select A Month"}
                        isSearchable={true}
                        isClearable={true}
                        value={this.props.selectedMonth}
                    />
                </div>
            </div>
        )
    }

    get defaultNoRecordsContent() {
        return (
            <div className={"records-default-container"}>
                <div>
                    <p>
                        There are no available manual entry billing records in the database for the
                        month of {" "} {this.props.selectedMonth.label} in the year {" "}
                        {this.props.selectedYear.label}
                    </p>
                </div>
                <div>
                    {this.props.isBillingAdmin
                        ? (
                            <Button
                                content={"Add New Record"}
                                color={"blue"}
                                icon={"plus"}
                                onClick={this.handleAddNewRecordClick}
                            />
                        )
                        : null
                    }
                </div>
            </div>
        )
    }

    get availableRecordsContent() {
        return (
            <div className={"records-table-container"}>
                <div className={"add-records-container"}>
                    {this.props.isBillingAdmin
                        ? (
                            <Button
                            content={"Add New Record"}
                            color={"blue"}
                            icon={"plus"}
                            onClick={this.handleAddNewRecordClick}
                            />
                        )
                        : null
                    }
                </div>
                <ManualEntryRecordsTable
                    ManualEntryBillingRecords={this.props.billingRecords}
                />
            </div>
        )
    }

    get pageContent() {

        const deleteRecordWarningContent = (
            <div className={"content"}>
                Are you sure you want to delete this Billing Record? <br/>
                THIS WILL PERMANENTLY DELETE THE RECORD FROM OUR DATABASE.
            </div>
        );
        const { showRecordsTable } = this.state;
        const { billingRecords, addNewRecordModalOpen, editRecordModalOpen, deleteBillingRecordWarning } = this.props;

        return (
            <div className={"manual-entry-records-page"}>
                <div>
                    {this.rangeSelectionContent}
                    {showRecordsTable
                        ? billingRecords.length > 0
                            ? this.availableRecordsContent
                            : this.defaultNoRecordsContent
                        : null
                    }
                </div>
                <Modal
                    centered={false}
                    open={addNewRecordModalOpen}
                >
                    <Modal.Header>
                        {"Create a New Billing Record"}
                    </Modal.Header>
                    <Modal.Content scrolling>
                        <AddEditBillingRecordForm />
                    </Modal.Content>
                    <Modal.Actions>
                        <Button
                            type="button"
                            color="red"
                            inverted
                            onClick={this.handleCloseModal}
                            >
                            Close
                        </Button>
                        <Button
                            type="submit"
                            color="green"
                            inverted
                            onClick={this.validateBillingRecordFormBeforeSubmit}
                            >
                            Submit
                        </Button>
                        <Button
                            type="submit"
                            color="green"
                            inverted
                            onClick={this.validateBillingRecordFormBeforeSubmitAndClear}
                            >
                            Submit & Add Another Record
                        </Button>
                    </Modal.Actions>
                </Modal>

                <Modal
                    centered={false}
                    open={editRecordModalOpen}
                >
                    <Modal.Header>
                        {"Edit A Billing Record"}
                    </Modal.Header>
                    <Modal.Content scrolling>
                        <AddEditBillingRecordForm />
                    </Modal.Content>
                    <Modal.Actions>
                        <Button
                            type="button"
                            color="red"
                            inverted
                            onClick={this.handleCloseModal}
                        >
                            Close
                        </Button>
                        <Button
                            type="submit"
                            color="green"
                            inverted
                            onClick={this.validateBillingRecordFormBeforeSubmit}
                        >
                            Submit
                        </Button>
                    </Modal.Actions>
                </Modal>

                <Confirm
                    open={deleteBillingRecordWarning}
                    content={deleteRecordWarningContent}
                    onCancel={this.handleCancelDeleteBillingRecordClick}
                    onConfirm={this.handleDeleteBillingRecordClick}
                />
            </div>
        )
    }

    render() {
        return (
            <div className="billing">
                <Header />
                <Grid relaxed={true}>
                    <Grid.Column width={3}>
                        <Sidebar>
                            <BillingSidebarButtons />
                        </Sidebar>
                    </Grid.Column>
                    <Grid.Column width={13}>
                        <Breadcrumb />
                        {this.pageContent}
                    </Grid.Column>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    isBillingAdmin: state.marvel.user.access.accessLevel.isBillingAdmin,

    billing_organizations: state.billing.organizations.billing_organizations,
    billingRecords: state.billing.manualEntryRecords.billingRecords,
    selectedYear: state.billing.manualEntryRecords.selectedYear,
    selectedMonth: state.billing.manualEntryRecords.selectedMonth,

    billingRecordObject: state.billing.addEditBillingRecords.billingRecordObject,
    addNewRecordModalOpen: state.billing.addEditBillingRecords.addNewRecordModalOpen,
    editRecordModalOpen: state.billing.addEditBillingRecords.editRecordModalOpen,
    orgTenantCountryObject: state.billing.addEditBillingRecords.orgTenantCountryObject,
    deleteBillingRecordWarning: state.billing.addEditBillingRecords.deleteBillingRecordWarning,
    recordIDForDelete: state.billing.addEditBillingRecords.recordIDForDelete,
});

const mapDispatchToProps = dispatch => ({
    setBreadCrumb: (crumb) => { dispatch(setBreadCrumb(crumb)) },
    getBRecords: (selectedRange) => { dispatch(getBillingRecords(selectedRange)) },
    populateFormOptions: () => { dispatch(getFormOptions()) },
    setYear: (year) => { dispatch(selectYear(year)) },
    setMonth: (month) => { dispatch(selectMonth(month)) },
    toggleAddModal: (dateString) => { dispatch(toggleAddRecordsModal(dateString)) },
    closeAddEditModal: () => { dispatch(closeBillingRecordsModal()) },
    validateManualEntryRecord: (billingRecordObject, clearForm) => { dispatch(validateBillingRecord(billingRecordObject, clearForm)) },
    toggleDeleteBillingRecordModal: (recordID) => { dispatch(toggleDeleteWarningForRecord(recordID)) },
    deleteCurrentBillingRecord: (recordID, selectedRange) => { dispatch(deleteBillingRecord(recordID, selectedRange)) },
    unmountManualEntryBillingRecords: () => { dispatch(unmountBillingRecords()) },
});


export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ManualEntryRecordsListPage)
